import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Card, CardImage } from '@blueprint/ui';
import { SkeletonRow } from '../Skeleton/Skeleton';

export const StyledLinkSkeleton = styled('div')(
    ({ theme: { focusRing } }) => css`
        :focus {
            box-shadow: ${focusRing};
            outline: 0;
        }
    `
);

export const StyledCard = styled(Card)(
    ({ theme }) => css`
        display: flex;
        flex-direction: column;
        border-radius: ${theme.borderRadius['300']};
        padding: 0;
        height: 100%;
        width: 17.5rem;

        ${CardImage} {
            margin: 0;
            min-width: 100%;
            height: 100%;
            object-fit: cover;
        }
    `
);

export const ShortSkeletonRow = styled(SkeletonRow)(
    ({ theme: { spacing } }) => css`
        margin-bottom: ${spacing['8px']};
    `
);

export const CardDetailsSkeleton = styled('div')(
    ({ theme: { spacing } }) => css`
        padding: ${spacing['spacing-2']};
        height: 240px;
    `
);
